"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vector_1 = require("../vector");
function matrix2Create(m11, m12, m21, m22, x, y) {
    return {
        m11: m11,
        m12: m12,
        m21: m21,
        m22: m22,
        x: x,
        y: y
    };
}
exports.matrix2Create = matrix2Create;
exports.identity = matrix2Create(1, 0, 0, 1, 0, 0);
function equals(m1, m2) {
    return m1.m11 === m2.m11 && m1.m12 === m2.m12 && m1.m21 === m2.m21 && m1.m22 === m2.m22 && m1.x === m2.x && m1.y === m2.y;
}
exports.equals = equals;
function translate(x, y) {
    return matrix2Create(1, 0, 0, 1, x, y);
}
exports.translate = translate;
function getTranslation(matrix) {
    return vector_1.Vector2.vec2Create(matrix.x, matrix.y);
}
exports.getTranslation = getTranslation;
function multiply(m1, m2) {
    var m11 = m1.m11 * m2.m11 + m1.m12 * m2.m21;
    var m12 = m1.m11 * m2.m12 + m1.m12 * m2.m22;
    var m21 = m1.m21 * m2.m11 + m1.m22 * m2.m21;
    var m22 = m1.m21 * m2.m12 + m1.m22 * m2.m22;
    var x = m1.m11 * m2.x + m1.m12 * m2.y + m1.x;
    var y = m1.m21 * m2.x + m1.m22 * m2.y + m1.y;
    return matrix2Create(m11, m12, m21, m22, x, y);
}
exports.multiply = multiply;
function rotate(degrees) {
    var rad = (degrees * Math.PI) / 180;
    return matrix2Create(Math.cos(rad), -Math.sin(rad), Math.sin(rad), Math.cos(rad), 0, 0);
}
exports.rotate = rotate;
function mirror(mirrorX, mirrorY) {
    return matrix2Create(mirrorX ? -1 : 1, 0, 0, mirrorY ? -1 : 1, 0, 0);
}
exports.mirror = mirror;
function apply(v, matrix) {
    return vector_1.Vector2.vec2Create(matrix.x + matrix.m11 * v.x + matrix.m12 * v.y, matrix.y + matrix.m21 * v.x + matrix.m22 * v.y);
}
exports.apply = apply;
function applyDirection(v, matrix) {
    return vector_1.Vector2.vec2Create(matrix.m11 * v.x + matrix.m12 * v.y, matrix.m21 * v.x + matrix.m22 * v.y);
}
exports.applyDirection = applyDirection;
function composite(rotationDegrees, mirrorX, mirrorY, x, y) {
    return multiply(translate(x, y), multiply(mirror(mirrorX, mirrorY), rotate(rotationDegrees)));
}
exports.composite = composite;
function inverse(matrix) {
    var det = matrix.m11 * matrix.m22 - matrix.m21 * matrix.m12;
    if (Math.abs(det) < Number.EPSILON) {
        throw new Error("Could not invert matrix, determinant is 0");
    }
    var invDet = 1.0 / det;
    var m11 = matrix.m22;
    var m12 = -matrix.m12;
    var m21 = -matrix.m21;
    var m22 = matrix.m11;
    var x = matrix.y * matrix.m12 - matrix.m22 * matrix.x;
    var y = -(matrix.y * matrix.m11 - matrix.m21 * matrix.x);
    return matrix2Create(invDet * m11, invDet * m12, invDet * m21, invDet * m22, invDet * x, invDet * y);
}
exports.inverse = inverse;
function setTranslation(position, matrix) {
    return matrix2Create(matrix.m11, matrix.m12, matrix.m21, matrix.m22, position.x, position.y);
}
exports.setTranslation = setTranslation;
function scale(scaleX, scaleY) {
    return matrix2Create(scaleX, 0, 0, scaleY, 0, 0);
}
exports.scale = scale;
